import React from 'react'

import {Props} from './types'

const ChevronRight: React.FC<Props> = props => (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 7.5L14.5 12L10 16.5" stroke="#21201F" strokeLinecap="round" strokeWidth="1.5" />
  </svg>
)

export default ChevronRight
